import { ExternalLink } from "lucide-react";
import type { Node, NodeProps } from "@xyflow/react";

import { formatDate, formatDeliveryMethod } from "@/lib/format";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle } from "./shared";
import type { DeliveryNodeData } from "./types";

type DeliveryFlowNode = Node<DeliveryNodeData, "delivery">;

function TrackingValue({ trackingNumber, trackingUrl }: { trackingNumber?: string | null; trackingUrl?: string | null }) {
  if (!trackingNumber) return <span>-</span>;
  if (!trackingUrl) return <span>{trackingNumber}</span>;

  return (
    <a
      href={trackingUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-primary hover:underline"
    >
      <span>{trackingNumber}</span>
      <ExternalLink className="size-3" />
    </a>
  );
}

export function DeliveryNode({ data }: NodeProps<DeliveryFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <FlowNodeCard title="Delivery">
        <FlowNodeRow label="Method" value={formatDeliveryMethod(data.deliveryMethod)} />
        <FlowNodeRow
          label="Tracking"
          value={<TrackingValue trackingNumber={data.trackingNumber} trackingUrl={data.trackingUrl} />}
        />
        <FlowNodeRow
          label="Estimated"
          value={
            data.estimatedDeliveryDate
              ? formatDate(data.estimatedDeliveryDate, {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })
              : "-"
          }
        />
      </FlowNodeCard>
    </>
  );
}
